import { BrowserQRCodeReader } from '@zxing/library';
import $ from "jquery";
import swal from "sweetalert";

$(document).on('turbolinks:load', function () {
    console.log('turbolinks:load . . .');
    const codeReader = new BrowserQRCodeReader();

    codeReader
        .decodeFromInputVideoDevice(undefined, 'video')
        .then((result) => {

            document.getElementById('result').textContent = result.text
            //console.log(result.text)
            let qrDataFromReader = result.text;
            let formData = new FormData();

            let qrCodeParams = {
                qr_data: qrDataFromReader
            };

            formData.append("qr_code_json_data", JSON.stringify(qrCodeParams));

            let str_begin = 'qwP9qXrrzbwT3cPvRE[Jhk0w981';
            let str_end = 'ABNdYYn';

            //let str_id = qrDataFromReader.split('https://poncebattery.com/v_w/').join('').split(str_begin)[1].split(str_end)[0];
            // let str_id = qrDataFromReader.split('v_w/')[1];
            let str_id = qrDataFromReader.split('_w/')[1];

            //Revisar si se encuentra en dominio ponce
            if(str_id === undefined){
                swal({
                    title: "¡Error!",
                    text: 'El código no pertenece a PONCE BATTERY 123',
                    icon: 'error',
                    confirm: {
                        text: "Aceptar",
                        value: true,
                        visible: true,
                        className: "",
                        closeModal: false
                    }
                }).then(() => {
                    location.reload();
                })

            }else{
                // getWarranty(str_id).then(function (result) {
                //     if (result == null) {
                //         //redirect form
                //         window.location.href = '/new_w/' + str_id;
                //     } else {
                //         //redirect show
                //         window.location.href = '/show_w/' + str_id;
                //     }
                // })
                window.location.href = '/check_w/' + str_id;
            }
        })
        .catch(
            err =>console.error(err)
        );

    async function getWarranty(str_id){
        var result = '';

        await $.ajax({
            type: 'GET',
            url: '/verify_warranty/' + str_id,
            contentType: "application/json",
            dataType: 'json',
            success: function (response) {
                result = response;
            }
        });
        return result;
    }
});
// window.addEventListener('load', function () {
//     const codeReader = new BrowserQRCodeReader()
//     console.log('ZXing code reader initialized')
//
//     const resultContainer = document.getElementById('result')
//
//     document.getElementById('startButton').addEventListener('click', async () => {
//         const video = document.getElementById('video')
//         // video.setAttribute('src', '../../resources/qrcode-video.mp4')
//         console.log("9999")
//         try {
//             const result = await codeReader.decodeFromVideo(video)
//             console.log(result)
//             resultContainer.textContent = result.text
//         } catch (err) {
//             console.error(err)
//             resultContainer.textContent = err
//         }
//     })
//
//     document.getElementById('resetButton').addEventListener('click', () => {
//         codeReader.reset()
//         resultContainer.textContent = ''
//         console.log('Reset.')
//     })
//
// })